export function normalizeMobileScaledTextareaProps(props = {}) {
  const {
    accessibilityLabel,
    "aria-label": ariaLabel,
    ...restProps
  } = props;

  if (ariaLabel != null && ariaLabel !== "") {
    return {
      ...restProps,
      "aria-label": ariaLabel,
    };
  }

  if (accessibilityLabel != null && accessibilityLabel !== "") {
    return {
      ...restProps,
      "aria-label": accessibilityLabel,
    };
  }

  return restProps;
}
